import { BoxPlotChartConfigType, ChartConfigType, PlotType } from '../types.ts';

const isWidgetDefaultSite = (siteKey: string, defaultSiteKey: string | undefined): boolean =>
  !defaultSiteKey || siteKey === defaultSiteKey;

const clearSensorAndTypeFields = (config: ChartConfigType): ChartConfigType => {
  switch (config.plotType) {
    case PlotType.LINEAR:
    case PlotType.AGGREGATED:
      return { ...config, sensors: [], plot: [] };
    case PlotType.HISTOGRAM:
      return { ...config, sensorId: '', provider: '' };
    case PlotType.SCATTER:
      return { ...config, sensorIdA: '', sensorIdB: '', providerA: '', providerB: '' };
    case PlotType.BOXPLOT:
      return {
        ...config,
        boxes:
          (config as BoxPlotChartConfigType).boxes?.map(box => ({
            ...box,
            sensorId: '',
            provider: '',
          })) ?? [],
      };
    default:
      return config;
  }
};

/** Keeps saved sensor/type on the widget's site tab; other site tabs start without them. */
export const getSiteScopedChartConfig = <T extends ChartConfigType | undefined>(
  config: T,
  siteKey: string,
  defaultSiteKey: string | undefined
): T => {
  if (!config || isWidgetDefaultSite(siteKey, defaultSiteKey)) {
    return config;
  }

  return clearSensorAndTypeFields(config) as T;
};
